module.exports = __webpack_public_path__ + "static/content_2_3_eg-ecc453216ce8f35c7778c78ed8cb832c.png";